<meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
<template>
  <div class="block galleryBlock backDark">
    <v-container>
      <h2 class="text-center">Device Status</h2>
      <v-data-table
        :headers="headers"
        :items="devices"
        class="elevation-1"
        disable-pagination
        hide-default-footer
        height="400px"
      >
        <template v-slot:item.status="{ item }">
          <span :class="{'green--text text--darken-2 font-weight-bold': item.status === 'online', 'red--text text--darken-2 font-weight-bold': item.status === 'offline'}">
            {{ item.status }}
          </span>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
//:items="devices"
import  discoveryAPI from "../../services/discoveryAPI"
export default {
  name: "DeviceStatus",
  data () {
      return {
        headers: [
          {
            text: 'Title',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          { text: 'Status', value: 'status' },
        
        ],
        devices: []
      }
  },
  methods:{
    getTD(){
      discoveryAPI.get('/td').then((response) => {
        response.data.items.forEach(element => {
          console.log(element.title)
          this.devices.push({
            name: element.title,
            status:'online'
          })
        });
      })
    }
  },
  mounted(){
    this.getTD();
  }
  
};
</script>

<style>
.backDark {
  background: #b0b5bf;
}
tbody tr:nth-of-type(even) {
    background-color: rgb(198, 198, 198);
  }
  tbody tr:nth-of-type(odd) {
    background-color: rgb(217 ,217, 217);
  }
  .v-data-table-header {
    background-color: rgb(198, 198, 198);
    color: white;
  }
  .v-data-footer {
    background-color: rgb(250 ,250, 250);
  }
  .theme--ligth.v-data-table thead  tr th {
    
    color: white;
    overflow-y: scroll;
  }
  /* width */
.v-data-table__wrapper::-webkit-scrollbar {
  width: 10px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
 
</style>